module.exports = __webpack_public_path__ + "img/full-mag-field.fb4c77bc.svg";